import { Map, List } from 'immutable';

export function request(state, { userId, uid }) {
    const legs = state.getIn([ 'legs', userId ], Map()).filter((v, k) => k !== uid);

    let bets = state.getIn([ 'bets', userId ], List());
    let bet = bets.find(x => x.get('uid') === uid);

    if (bet && bet.get('type') === 'SGL') {
        bets = bets.filter(x => !x.get('legs').contains(uid));
    }

    return state
        .setIn([ 'bets', userId ], bets)
        .setIn([ 'legs', userId ], legs);
}
